<template>
    <div>
        <div v-if="!!file"
            @click.shift="$emit('shift-click', file)"
            @click.exact="
                () => {
                    if (interactive) $emit('click', file);
                }
            "
            :class="`bg-gray-100 dark:bg-gray-700 text-center p-3 cursor-pointer${
            !selector && interactive
                ? 'transform hover:-translate-y-1 hover:shadow-lg transition duration-150'
                : 'transition-all duration-75'
        }  ${
            highlight ? 'border-4 border-indigo-500 border-box' : 'border-0'
        }  rounded overflow-hidden`"
        >
            <div>
                <span v-if="draggable"
                  class="handle pr-1 text-gray-400 dark:text-gray-200 hover:text-gray-600 dark:hover:text-gray-400 cursor-pointer transition duration-150 transform hover:scale-105"
                  title="Drag to reorder items">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 17l-4 4m0 0l-4-4m4 4V3" />
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7l4-4m0 0l4 4m-4-4v18" />
                    </svg>
                </span>
                <span
                    v-if="deletable"
                    @click="handleDelete"
                    class="text-gray-400 dark:text-gray-200 hover:text-gray-600 dark:hover:text-gray-400 cursor-pointer transition duration-150 transform hover:scale-105"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-5 w-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>
                </span>
                <img :class="maxHeight"
                     class="max-w-full w-auto h-auto m-auto text-black dark:text-white"
                     style="min-width: 6rem;"
                     :src="src"
                     :alt="file.file_name">
            </div>
            <div class="text-center mt-3 text-black dark:text-white">
                {{ file ? file.file_name : null }}

                <span v-if="debugStore.debugMode && file && file.id" class="font-mono">
                    [Media:{{ file.id }}]
                </span>
            </div>
        </div>
        <div class="flex mt-1" v-if="feedsIntoGallery">
          <label class="flex items-center">
            <input  v-model="selectedForGallery" type="checkbox" class="form-checkbox">
            <span class="ml-2 text-xs">Included in gallery</span>
          </label>
        </div>
    </div>
</template>

<script>
import EventBus from '../../eventBus';
import {useDebugStore} from "../../stores/debug";

export default {
    name: "MediaItem",
    props: {
        file: {
            type: Object,
            required: false,
        },
        draggable: {
            type: Boolean,
            default: false,
        },
        deletable: {
            type: Boolean,
            default: false,
            required: false
        },
        feedsIntoGallery: Boolean,
        selector: Boolean,
        highlight: Boolean,
        inGallery: Boolean,
        interactive: {
            type: Boolean,
            default: true,
        },
        maxHeight: {
            type: String,
            default: 'max-h-48'
        }
    },
    data() {
        return {
            selectedForGallery: this.inGallery,
            debugStore: useDebugStore(),
        };
    },
    methods: {
        handleDelete() {
            this.$emit('delete', this.file);
            EventBus.$emit('delete', this.file);
        },
    },
    computed: {
        src() {
            return (this.file.url || this.file.logo.url) + '?' + new Date().getTime()
        }
    },
    watch: {
        "selectedForGallery": function (includedInGallery){
            if (includedInGallery) {
                this.$emit('add-to-gallery', this.file);
                EventBus.$emit('add-to-gallery', this.file);
            }
            else {
                this.$emit('remove-from-gallery', this.file);
                EventBus.$emit('remove-from-gallery', this.file);
            }
        }
    }
};
</script>
